import React, { useState } from 'react';
import './support.css';
import axios from 'axios';

const SupportTicketForm = () => {
  const [formData, setFormData] = useState({
    subject: '',
    name: '',
    email: '',
    service: '',
    phone: '',
    website: '',
    message: '',
    attachment: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleReset=()=>{
    setFormData({
      subject: '',
      name: '',
      email: '',
      service: '',
      phone: '',
      website: '',
      message: '',
      attachment: null,
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append('subject', formData.subject);
    form.append('name', formData.name);
    form.append('email', formData.email);
    form.append('service', formData.service);
    form.append('phone', formData.phone);
    form.append('website', formData.website);
    form.append('message', formData.message);
    form.append('attachment', formData.attachment);
    
    debugger
    axios.post('https://gantasoft.com//gantasoft/postsupportrequest.php', form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(res => {
      
      if (res.status === 200) {
        
        res.data.message ? alert(res.data.message): alert("success")
       handleReset();
      }
    }).catch(e => {
      alert(e);
    });
  
  };

  return (
    <section id="home" className="hero home section ">
    <div className="container">
      <div className="row gy-4">
      
    <div className="support-form-container dark-background">
    <h2>Raise a Support Ticket</h2>
    <p>Support Timing: 11 AM to 8 PM</p>
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label>Subject</label>
        <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Your name</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Email Address</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Service</label>
        <select name="service" value={formData.service} onChange={handleChange} required>
          <option value="">Select a service</option>
          <option value="1">Domain issues</option>
          <option value="2">Server issues</option>
          <option value="3">Website issues</option>
          <option value="4">Email issues</option>
        </select>
      </div>
      <div className="form-group">
        <label>Phone Number</label>
        <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Website URL</label>
        <input type="url" name="website" value={formData.website} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>Message</label>
        <textarea name="message" value={formData.message} onChange={handleChange} required></textarea>
      </div>
      <div className="form-group">
        <label>Attachments</label>
        <input type="file" name="attachment" onChange={handleChange} />
      </div>
      <button type="submit">Submit</button>
    </form>
   </div>
      </div>
    </div>
  </section>
  );
};

export default SupportTicketForm;
